import type { RouteRecordRaw } from 'vue-router';

export const routes: RouteRecordRaw[] = [
  {
    path: '/cdp',
    redirect: '/cdp/projects',
  },
  {
    path: '/cdp/projects',
    name: 'cdp-projects',
    component: () => import('./pages/ProjectsPage.vue'),
    meta: { title: 'Проекты' },
  },
  {
    path: '/cdp/events',
    name: 'cdp-events',
    component: () => import('./pages/EventsPage.vue'),
    meta: { title: 'События' },
  },
  {
    path: '/cdp/contacts',
    name: 'cdp-contacts',
    component: () => import('./pages/ContactsPage.vue'),
    meta: { title: 'Контакты' },
  },
  {
    path: '/cdp/event-types',
    name: 'cdp-event-types',
    component: () => import('./pages/EventTypesPage.vue'),
    meta: { title: 'Типы событий' },
  },
  {
    path: '/cdp/rules',
    name: 'cdp-rules',
    component: () => import('./pages/RetentionRulesPage.vue'),
    meta: { title: 'Retention-правила' },
  },
  {
    path: '/cdp/retention',
    name: 'cdp-retention',
    component: () => import('./pages/RetentionJournalPage.vue'),
    meta: { title: 'Retention' },
  },
];
